import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
import { searchFormItems } from './config';
import LogDetails from './LogDetails.vue';
import { PAGE_URL } from '@/api/system/sys-log';
import { formatterDate } from '@/utils/common';
import { XTable } from '@/components/index';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Log',
  setup: function setup(__props) {
    var tableInstance = ref();
    var LogDetailsRef = ref();
    var headerButton = [];
    function search(formData) {
      var _tableInstance$value;
      var searchFormData = _objectSpread({}, formData);
      if (searchFormData.timeRange) {
        searchFormData.timeRange = formData.timeRange[0] + ',' + formData.timeRange[1];
      }
      console.error(searchFormData);
      (_tableInstance$value = tableInstance.value) === null || _tableInstance$value === void 0 || _tableInstance$value.load(searchFormData);
    }
    function reset() {
      var _tableInstance$value2;
      (_tableInstance$value2 = tableInstance.value) === null || _tableInstance$value2 === void 0 || _tableInstance$value2.load({});
    }
    function details(row) {
      var _LogDetailsRef$value;
      (_LogDetailsRef$value = LogDetailsRef.value) === null || _LogDetailsRef$value === void 0 || _LogDetailsRef$value.open(row);
    }
    return function (_ctx, _cache) {
      var _component_XSearchForm = _resolveComponent("XSearchForm");
      var _component_ElTableColumn = _resolveComponent("ElTableColumn");
      var _component_el_tag = _resolveComponent("el-tag");
      var _component_el_link = _resolveComponent("el-link");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_XSearchForm, {
            ref: "searchForm",
            items: _unref(searchFormItems),
            onSearch: search,
            onReset: reset
          }, null, 8, ["items"]), _createVNode(_component_XFlexCtx, {
            flex: 1
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XTable), {
                ref_key: "tableInstance",
                ref: tableInstance,
                url: _unref(PAGE_URL),
                "show-index": "",
                selectable: "",
                "header-buttons": headerButton,
                "el-table-props": {
                  border: true
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_ElTableColumn, {
                    label: "功能模块",
                    prop: "module",
                    width: "150"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "操作描述",
                    prop: "message",
                    width: "250"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "请求地址",
                    prop: "reqUrl",
                    width: "250"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "操作用户",
                    prop: "username",
                    width: "100"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "操作耗时(ms)",
                    prop: "takeUpTime",
                    width: "120",
                    align: "right"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "请求IP",
                    prop: "reqIp",
                    width: "160"
                  }), _createVNode(_component_ElTableColumn, {
                    label: "操作状态",
                    prop: "resultType",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref) {
                      var row = _ref.row;
                      return [row.resultType === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "success"
                      }, {
                        default: _withCtx(function () {
                          return _cache[0] || (_cache[0] = [_createTextVNode(" 正常 ")]);
                        }),
                        _: 1
                      })) : row.resultType === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "danger"
                      }, {
                        default: _withCtx(function () {
                          return _cache[1] || (_cache[1] = [_createTextVNode(" 异常 ")]);
                        }),
                        _: 1
                      })) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  }), _createVNode(_component_ElTableColumn, {
                    label: "创建时间",
                    prop: "createdAt",
                    align: "center",
                    formatter: function formatter(row) {
                      return _unref(formatterDate)(row.createdAt);
                    }
                  }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
                    label: "操作",
                    width: "150",
                    align: "center"
                  }, {
                    default: _withCtx(function (_ref2) {
                      var row = _ref2.row;
                      return [_createVNode(_component_el_link, {
                        underline: false,
                        icon: "search",
                        type: "primary",
                        onClick: function onClick($event) {
                          return details(row);
                        }
                      }, {
                        default: _withCtx(function () {
                          return _cache[2] || (_cache[2] = [_createElementVNode("span", {
                            style: {
                              "padding": "0 6px 0 4px"
                            }
                          }, "查看详情", -1)]);
                        }),
                        _: 2
                      }, 1032, ["onClick"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["url"])];
            }),
            _: 1
          }), _createVNode(LogDetails, {
            ref_key: "LogDetailsRef",
            ref: LogDetailsRef
          }, null, 512)];
        }),
        _: 1
      });
    };
  }
});